import {Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserProfile, UserRole } from 'app/profile/model/model';
import { UserService } from 'app/profile/services/user.service';

import { Browser } from '@capacitor/browser';


import {NavService} from 'shared/nav/nav.service';
import { DefaultPage } from '../default-page/default-page';
import { zip } from 'rxjs';

@Component({
  selector: 'generic-page',
  templateUrl: 'generic-page.html',
  styleUrls: ['generic-page.scss'],
})
export class GenericPage extends DefaultPage {

  public type: string;

  public data: string;

  constructor(
    public navService: NavService,
    private userService: UserService,
    private translateService: TranslateService,
  ) {
    super(navService);
    this.type = navService.get('type');
    this.data = navService.get('data').replace(/\\n/g, "\n");
  }

}
